import React from "react";
import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
import styles from "./index.module.css";

const CommonButton = ({ label, handleClick }) => {
  return (
    <Button
      variant="outlined"
      className={styles.customButton}
      startIcon={<AddIcon />}
      onClick={handleClick}
    >
      {label}
    </Button>
  );
};

export default CommonButton;
